var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavMaintenance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7 19.2L13.6 10.1C14.5 7.8 14 5.1 12.1 3.2C10.1 1.2 7.1 0.8 4.7 2L9 6.3L6.3 9L2 4.7C0.8 7.1 1.2 10.1 3.2 12.1C5.1 14 7.8 14.5 10.1 13.6L19.2 22.7C19.6 23.1 20.3 23.1 20.7 22.7L22.7 20.7C23.1 20.3 23.1 19.6 22.7 19.2ZM20 20.6L11 11.6C10.2 12.2 9.2 12.5 8.2 12.5C5.7 12.5 3.7 10.5 3.7 8C3.7 7.8 3.7 7.6 3.8 7.4L6.3 9.9L9.9 6.3L7.4 3.8C7.6 3.7 7.8 3.7 8 3.7C10.5 3.7 12.5 5.7 12.5 8.2C12.5 9.2 12.2 10.2 11.6 11L20.6 20L20 20.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMaintenance);
export default __webpack_public_path__ + "static/media/nav_maintenance.92f401cb7d0c0a06ae0a7495ebe1cda8.svg";
export { ForwardRef as ReactComponent };